<template>
  <div
    id="container"
    class="anchor-container"
    :class="{
      isPackUp: isPackUp,
      ischangearea: ischangearea,
      packUpNotChange: isPackUp && !ischangearea,
      packAndChange: isPackUp && ischangearea,
    }"
  >
    <!-- <div class="anchor-aside"> -->
    <aheader class="anchor-header"></aheader>
    <asideLeft class="anchor-asideleft"></asideLeft>
    <acenter @hook:mounted="acenterMounted" class="anchor-center"></acenter>
    <!-- </div> -->
    <videoArea class="video-container"></videoArea>
    <asideRight class="anchor-asideright"></asideRight>
    <check></check>
    <tips :content="content" v-if="content" :time="time"></tips>
  </div>
</template>

<script>
import { setImgOrSvg } from "@/utils/themeImg"
import aheader from "@/components/include/aheader";
import acenter from "@/components/include/acenter";
import asideLeft from "@/components/include/aside-left";
import asideRight from "@/components/include/aside-right";
import tips from "@/components/include/tips";
import check from "@/components/check";
import videoArea from "@/components/video";
import Bus from "@/components/doc/bus";
import { globalUpdateLabel } from "@/utils/common";
import { mapGetters } from 'vuex';

export default {
  components: {
    aheader,
    asideLeft,
    acenter,
    asideRight,
    check,
    videoArea,
    tips,
  },
  computed: {
    isPackUp() {
      return this.$store.getters.isPackUp;
    },
    ischangearea() {
      return this.$store.getters.isChangeArea;
    },
    defaultLiveCid() {
      return this.$store.state.defaultInfo.defaultLiveCid;
    },
    ...mapGetters(['language'])
  },
  created() {
    this.init();
  },
  mounted() {
    navigator.mediaDevices.ondevicechange = () => {
      console.log("ondevicechange emit" )
      Bus.$emit('ondevicechange');
      Bus.$emit('ondevicechange2');
      Bus.$emit('ondevicechange3');
    };

  },
  data() {
    return {
      content: null,
      time: null,
      changeArea: false,
      setShow: true
    };
  },
  beforeDestroy() {
    Bus.$off("tips");
  },
  methods: {
    acenterMounted(){
      setImgOrSvg()
    },
    init() {
      console.log(performance, "performance.navigation.type");
      Bus.$on("tips", (info) => {
        this.content = info.content;
        this.time = info.time;
      });
      sessionStorage.removeItem("oldErea");
      /**
       * 计算视频区大图时显示的高度，解决文档列表展开收起，视频高度显示问题
       * setShow为false的时候，不显示文档列表，true的时候，显示文档列表
       * changeArea是false的时候，文档大图，视频高度使用原始高度，去掉赋值的高度
       * changeArea是true的时候，视频大图，视频高度根据是否显示文档列表计算，显示文档列表的高度为-172px，不显示文档列表的高度为-70px
      */
      Bus.$on("set-show", info => {
        console.log(info, "set-show");
        this.setShow = info;
        if(this.$store.getters.isChangeArea) {
          if(info) {
            document.querySelector('.video-container').style.height = 'calc(100% - 172px)';
          } else {
            document.querySelector('.video-container').style.height = 'calc(100% - 70px)';
          }
        } else {
          document.querySelector('.video-container').style.height = '';
        }
      })
      Bus.$on('ischangearea', (info)=>{
        // this.changeArea = info;
        console.log(this.setShow)
        if(!info) {
          document.querySelector('.video-container').style.height = '';
        } else {
          if(!this.setShow) {
            document.querySelector('.video-container').style.height = 'calc(100% - 70px)';
          }
        }
      })
    },
  },
  watch:{
    language: {
      immediate: true,
      handler(n) {
        if (n) {
          this.$i18n.locale = n;
        }
      },
    },
    defaultLiveCid: {
      handler(newVal) {
        if (!newVal) return;
        globalUpdateLabel();
      },
      immediate: true,
    },
  }
};
</script>

<style scoped lang="scss">
.anchor-container {
  position: relative;
  height: 100%;
  width: 100%;
  min-width: 1200px;
  min-height: 772px;
  .anchor-aside {
    display: inline-block;
    width: calc(100% - 270px);
    float: left;
    height: 100%;
  }
}

.anchor-header {
  background-color: $headerbg-color;
  width: 100%;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #292c51;
  border-right: 1px solid #292c51;
  box-sizing: border-box;
}
.anchor-asideleft {
  position: relative;
  z-index: 1000;
  width: 80px;
  height: calc(100% - 40px);
  float: left;
  // background: linear-gradient(180deg, #1B1E40,#120E25);
  border-right: 1px solid #292c51;
  box-sizing: border-box;
}
.anchor-center {
  width: calc(100% - 380px);
  float: left;
  height: calc(100% - 40px);
  position: relative;
  border-right: 1px solid #292c51;
  box-sizing: border-box;
}
.anchor-center-full{
  width: 100%;
  height: 100%;
  border: none;
}
.anchor-asideright {
  width: 300px;
  float: right;
  height: calc(100% - 198px);
  // 新加
  position: absolute;
  right: 0;
  top: 198px;
}
.video-container {
  width: 300px;
  float: right;
  position: absolute;
  right: 0;
  top: 40px;
  // padding: 0 10px;
  // box-sizing: border-box;
}
.video-full-container{
  width: 100%;
  height:100%;
  top:0;
}
.isPackUp {
  .anchor-aside {
    width: 100%;
  }
  // 新加
  .anchor-header {
    width: calc(100% - 1px);
  }
  .anchor-center {
    width: calc(100% - 80px);
  }
  // *********************
  .anchor-asideright {
    width: 0px;
    overflow: hidden;
    display: none;
  }
}
.ischangearea {
  .video-container {
    width: calc(100% - 370px);
    position: absolute;
    left: 70px;
    top: 40px;
    height: calc(100% - 172px);
    border-right: 1px solid #292c51;
    background: #000;
    padding: 0;
  }
  .video-full-container{
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
  }
}
.packUpNotChange {
  .video-container {
    display: none;
  }
}
.packAndChange {
  .video-container {
    width: calc(100% - 71px);
  }
}
</style>
